import { Injectable } from '@angular/core';
import { AnalyticsData } from '../../../models/analytics-data';
import { MobileAppLinks } from '../../../models/mobile-app-links';

@Injectable()
export class AppStoreLinksService {
  getStoreAppLinks(urls: any, payload: AnalyticsData): MobileAppLinks {
    return {
      ios: payload ? this.addParametersToUrl(urls[payload.sourcePage].IOS, payload) : '',
      android: payload ? this.addParametersToUrl(urls[payload.sourcePage].ANDROID, payload) : '',
      unified: payload ? this.addParametersToUrl(urls[payload.sourcePage].UNIFIED, payload) : ''
    } as MobileAppLinks;
  }

  addParametersToUrl(url: any, payload: AnalyticsData): string {
    return `${url}?ctalocation=${payload.ctalocation}&ship=${payload.shipCode}&saildate=${payload.saildate}&bkgid=${payload.bkgid}&paxid=${payload.paxid}`;
  }
}
